import React from 'react';
import { HighlightedCriteria } from 'src/components/Strategy/shared';
import type { StrategyCodeViewProps } from 'src/components/Strategy/shared/types';

/**
 * View for strategies that use template-based criteria rendering
 * Used by: SCOUT_LIST, REFERRALS, NOT_REFERRING
 */
const HighlightedCriteriaView: React.FC<StrategyCodeViewProps> = ({
  criteriaInputs,
  strategyDetails,
}) => {
  const criteriaTemplate = strategyDetails?.template?.criteria_template;

  if (!criteriaTemplate) {
    return null;
  }

  return (
    <div className="text-secondary text-base leading-relaxed">
      <HighlightedCriteria
        criteriaTemplate={criteriaTemplate}
        criteriaInputs={criteriaInputs}
      />
    </div>
  );
};

export default HighlightedCriteriaView;
